import { useEffect } from 'react'
import { identify, Identify, track, init } from '@amplitude/analytics-browser'
import { Routes, Route } from 'react-router-dom'

import { MedicalIdDisplay } from './features/medical-id-display'
import { WorkspaceInvitationsPage } from './pages/workspace-invitations'

const isUserURL = window.location.href.includes('/user')

const App = () => {
  useEffect(() => {
    if (isUserURL) {
      return
    }

    const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY

    init(amplitudeApiKey!)
    const identifyObj = new Identify()
    identify(identifyObj)
    track('Read info on web')
  }, [])

  return (
    <Routes>
      <Route path="/" element={<MedicalIdDisplay />} />
      <Route path="/user/*" element={<MedicalIdDisplay />} />
      <Route
        path="/workspace-invitations"
        element={<WorkspaceInvitationsPage />}
      />
    </Routes>
  )
}

export default App
